import { Component, OnInit } from '@angular/core';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { EOTeamGroup } from '../../../modal/entity.modal';
import { Subject } from 'rxjs';
import { PosHttpService } from '../../../services/pos.http.service';
import { TeamGroupModelComponent } from './team-group-model/team-group-model.component';

@Component({
  selector: 'app-team-group',
  templateUrl: './team-group.component.html',
  styleUrl: './team-group.component.scss'
})
export class TeamGroupComponent implements OnInit {
  constructor(private posHttpSvcs: PosHttpService, private toastr: FnToasterService, private fnModalSvcs: FnModalService) {
  }

  ngOnInit(): void {
    this.loadData();
  }
  showData = false;

  uiMap = {
    isDataLoaded: false,
  };

  config: FnTableConfig = {
		uniqueKey: 'primaryKey',
		defaultSortKey: 'primaryKey',
		tableAction: new Subject<TableAction>(),
	};

  rowMetaArray: FnTableMetaData[] = [
		{
			key: 'primaryKey',
			description: 'Primary Key',
			isHidden: true,
			isSortable: true,
			type: 'number',
		},
		{
			key: 'id',
			description: 'ID',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'textDesc',
			description: 'Friendly Name',
			type: 'string',
			isSortable: true,
		},
		{
			key: 'isActive',
			description: 'isActive',
			type: 'string',
			isSortable: true,
		}
	];

	teamGroupArray: EOTeamGroup[] = [];


	loadData() {
		this.posHttpSvcs.authGet('v1/ui/loadEOTeamGroupData', 'loadEOTeamGroupData').subscribe((resp: any) => {
			if (resp.isError) {
				this.toastr.error('Invalid Team Group Data ⚠️');
				return;
			}
			this.teamGroupArray = resp.data;
			this.showData = false;
		    this.refreshTableData();
			this.uiMap.isDataLoaded = true;
		});
	}
  updateRowAction(event: EOTeamGroup) {
      const teamGrpModal = this.fnModalSvcs.openCustomModal(TeamGroupModelComponent, {
        data: {
          eoTeamGroup: event,
        },
		hasBackdrop: true,
          width: '500px',
      })
      teamGrpModal.afterClosed().subscribe((objectHash) => {
        if(objectHash != undefined){
        this.addUpdateteamGrp(objectHash);
        }
      });
    }

  deleteRowAction(event: EOTeamGroup) {
      const dialogRef = this.fnModalSvcs.openConfirmModal({
        isConformationMdl: true,
        content: 'Are you sure you want to delete Team Group ?',
        type: 'danger',
      });
      dialogRef.afterClosed().subscribe(doAction => {
        if (doAction) {
          this.posHttpSvcs.authDeleteWithBody('v1/ui/deleteTeamGroup', event.primaryKey, event).subscribe(resp => {
            this.loadData();
          })
        }
      });
  
    }

  openActionMdl() {
    const teamGrpModal = this.fnModalSvcs.openCustomModal(TeamGroupModelComponent, {
      data: {
      },
	  hasBackdrop: true,
	  width: '500px',
    })
    teamGrpModal.afterClosed().subscribe((objectHash) => {
		if(objectHash != undefined){
			this.addUpdateteamGrp(objectHash);
		}
    });
  }

  addUpdateteamGrp(objectHash: any) {
		this.posHttpSvcs.authPut('v1/ui/saveTeamGrp', 'saveTeamGrp', objectHash).subscribe(resp => {
			if (resp.isError) {
				this.toastr.error(' Team group is not added ⚠️');
				return;
			} else {
				this.toastr.success("added successfully");
				this.loadData();
			}
		})

	}
  
  refreshTableData() {
		if (this.config.tableAction.closed) {
			this.config.tableAction = new Subject<TableAction>();
		}
		this.config.tableAction.next({
			data: this.teamGroupArray,
			action: TABLE_ACTION_TYPE.REFRESH,
		});
	}

}

